<template>
  <div class="box" id="top_bar">
    <div class="header">
      <img src="@/assets/img/unnamed.png" alt class="logo" />
      <div class="nav_box">
        <div class="nav_list" @click="Go('privacypolicy')">Privacy Policy</div>
        <div class="nav_list" @click="Go('terms')">Terms of Service</div>
      </div>
    </div>
    <div class="h_title">Privacy Policy</div>
    <div class="box">
      <div class="entry-content content-area">
        <h4>Data Privacy Statement</h4>
        <p><br><b>1.0 Introduction</b></p>
        <p>Your privacy is important to us. This privacy statement explains the personal data Choice Microfinance Bank
          (hereby referred to as “Choice Bank”) collects, how Choice Bank processes it, and for what purposes.<br>This
          statement should be read together with the Terms and Conditions of Use for other Choice Bank products and
          services. Where there is a conflict, this statement will prevail.<br>This statement applies to all customers,
          partners, agents and all visitors frequenting any of Choice Bank premises.</p>
        <p><br><b>2.0 Definitions</b><br>References to</p>
        <p><br><b>2.1 “You” means:</b><br></p>
        <ul>
          <li><b>customer</b>&#8211; the person who subscribes to, uses or purchases any of our products and services or
            accesses our websites and includes any person who accesses any of the products and services you have
            subscribed to.</li>
          <li>Any visitor that is a person (including contractors/subcontractors or any third parties) who gains access to
            any Choice Bank premises.</li>
          <li>Any supplier who has been contracted by Choice Bank and executed a Supplier contract.</li>
        </ul>
        <div><br></div>
        <p><b>2.2 “Choice Bank”, “we” or “us”, “our” and “ours” means Choice Bank</b><br>The word “includes” means that
          what follows is not necessarily exhaustive and therefore the examples given are not the only things/situations
          included in the meaning or explanation of that text.</p>
        <p><b>3.0 Statement Details</b></p>
        <p><b><br></b><b>3.1 Collection of Information</b></p>
        <p><b><br></b><b>3.1.1</b> We collect your personal information with your knowledge and consent when you do any of
          the following (please note that this list is not exhaustive):</p>
        <ul>
          <li>register for a specific product or service, including but not limited to mobile app, internet banking and
            agency banking.</li>
          <li>buy, subscribe to or use a Choice Bank product or service online, on the cloud, on a mobile or other device,
            in a Choice physical Bank premise.</li>
          <li>subscribe to Choice Bank or third-party services, Short Message Service (SMS), email or social media
            platforms;</li>
          <li>ask Choice Bank for more information about a product or service or contact Choice Bank with a query or
            complaint;</li>
          <li>respond to or participate in a survey, marketing promotion, prize competition or special offer;</li>
          <li>visit, access or use Choice Bank websites or it’s affiliates;</li>
          <li>We may also collect your information from other organizations including credit-reference bureaus, fraud
            prevention agencies and business directories;</li>
          <li>We may collect your information when you interact with us as a supplier, agent, or partner as prescribed in
            this statement;</li>
          <li>We also collect information when you visit any of our bank premises.</li>
        </ul>
        <div><br></div>
        <p><b>3.1.2 </b>We do not onboard minors (any person under 18 years of age) except where you additionally register
          on their behalf as their parent and/ or legal guardian. If you allow a child to use our services, you should be
          aware that their personal information could be collected as described in this statement.<br><br><b>3.2 What
            Information is collected?</b><br>The information we collect and store about you includes but is not limited to
          the following:</p>
        <p><br><b>3.2.1 </b>Your identity registration information, including your name, photograph, address, location,
          phone number, identity document type and number, date of birth, email address, age, gender and mobile number
          portability records.</p>
        <p><br><b>3.2.2</b> Your credit or debit-card information, information about your bank account numbers and SWIFT
          codes or other banking information.</p>
        <p><br><b>3.2.3</b> Your transaction information when you use our banks service.</p>
        <p><br><b>3.2.4</b> Your preferences for particular products and services, based on information provided by you or
          from your use of Choice Bank’s systems, products and services.</p>
        <p><br><b>3.2.5</b> Name, family details, age, profiling information such as level of education, bank account
          status, income brackets, etc. collected as part of surveys conducted by Choice Bank and their agents on behalf
          of Choice Bank.</p>
        <p><br><b>3.2.6</b> Your contact with us, such as when you: call us or interact with us through social media,
          email (we may record your conversations, social media or other interactions with us), register your biometric
          information such as your voice, finger prints e.t.c, or visit a Choice Bank branch.</p>
        <p><br><b>3.2.7</b> Your account information, such as your handset type/model, tariff, account statements, and
          transfer transactions.</p>
        <p><br><b>3.2.8</b> We use Closed Circuit Television (CCTV) surveillance recordings. CCTV Devices are installed at
          strategic locations to provide a safe and secure environment in all Choice Bank premises as a part of our
          commitment to community safety, security and crime prevention.</p>
        <p><br><b>3.2.9</b> When you use Choice Bank WIFI for guest and visitors, we collect email IDs and will provide
          user name and password. We record the device address and also log traffic information in the form of sites
          visited, duration and date sent/received.<br><br><b>3.3 Use of Information</b><br>We may use and analyze your
          information for the following purposes:</p>
        <p><br><b>3.3.1</b> Processing products and services that you have accessed from Choice Bank or our systems</p>
        <p><br><b>3.3.2</b> Billing you for using our products or services;</p>
        <p><br><b>3.3.3</b> Responding to any of your queries or concerns;</p>
        <p><br><b>3.3.4</b> Verifying your identity information through publicly available and/or restricted government
          databases in order to comply with applicable regulatory and statutory requirements;</p>
        <p><br><b>3.3.5</b> Carrying out validity checks, credit checks and credit scoring;</p>
        <p><br><b>3.3.6</b> Keeping you informed generally about new products and services and contacting you with offers
          or promotions based on how you use our or products and services unless you opt out of receiving such marketing
          messages (you may contact Choice Bank at any time to opt out of receiving marketing messages);</p>
        <p><br><b>3.3.7</b> to comply with any legal, governmental or regulatory requirement or for use by our lawyers in
          connection with any legal proceedings;</p>
        <p><br><b>3.3.8</b> In business practices including for quality control, training and ensuring effective systems
          operations;</p>
        <p><br><b>3.3.9</b> To protect our network including to manage our systems network security.</p>
        <p><br><b>3.3.10</b> To understand how you use our products and services for purposes of developing them.</p>
        <p><br><b>3.3.11</b> Preventing and detecting fraud or other crimes and for debt recovery;</p>
        <p><br><b>3.3.12</b> For research, statistical, survey and other scientific or business purposes;</p>
        <p><br><b>3.3.13</b> Administer any of our online platforms/websites.</p>
        <p><br><b>3.4. Categories of Data</b><br>Categories of Personal Data as defined in the Data Protection Act of
          Kenya may be processed depending on the particular types of products and services you have subscribed to.</p>
        <p><br><b>3.5. Lawful Basis for processing your information<br></b>We will process your personal information based
          on any of the lawful basis provided for under the Data Protection Law:</p>
        <p><br><b>3.5.1</b> The performance of a Product/Service Agreement with you;</p>
        <p><br><b>3.5.2</b> Choice Bank’s legitimate business interests;</p>
        <p><br><b>3.5.3</b> Compliance with a mandatory legal or statutory obligation;</p>
        <p><br><b>3.5.4</b> Consent you provide;</p>
        <p><br><b>3.5.5</b> Public interest;</p>
        <p><br><b>3.5.6</b> Your vital interest.</p>
        <p><br><b>3.6. Retention of Information</b><br>We will only retain your personal data for as long as reasonably
          necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal,
          regulatory, tax, accounting or reporting requirements. We may retain your personal data for a longer period in
          the event of a complaint or if we reasonably believe there is a prospect of litigation in respect to our
          relationship<br>with you.<br>To determine the appropriate retention period for personal data, we consider the
          amount, nature and sensitivity of the personal data, the potential risk of harm from unauthorized use or
          disclosure of your personal data, the purposes for which we process your personal data and whether we can
          achieve those purposes through other means, the need to comply with our internal policy and the applicable
          legal, regulatory, tax, accounting or other requirements.<br><br><b>4.0 Disclosure of Information</b></p>
        <p><b><br>4.1</b> Any disclosure of your information shall be in accordance with applicable law and regulations.
          Choice Bank shall assess and review each application for information and may decline to grant such information
          to the requesting party.</p>
        <p><br><b>4.2</b> We may disclose your information to:<br></p>
        <ul>
          <li>law-enforcement agencies, regulatory authorities, courts or other statutory authorities in response to a
            demand issued with the appropriate lawful mandate and where the form and scope of the demand is compliant with
            the law.</li>
          <li>our subsidiaries, associates, partners, software developers or agents who are involved in delivering Choice
            Bank products and services you order or use;</li>
          <li>Fraud prevention and Anti money laundering agencies, credit- reference agencies;</li>
          <li>publicly available and/or restricted government databases to verify your identity information in order to
            comply with regulatory requirements;</li>
          <li>debt-collection agencies or other debt-recovery firms;</li>
          <li>Any other person that we deem legitimately necessary to share the data with.</li>
        </ul>
        <div><br></div>
        <p><b>4.3 </b>Some of your information may be passed on to any person whom you receive mobile money transfer from
          or send or intend to send mobile money to from your account. Your information may be available to any third
          party involved in the operation of the mobile money transfer service including but not limited to M-PESA,
          Airtel, T-kash, interoperability partners, ATM Switch providers and vendors of money transfer technology
          platforms.</p>
        <p><br></p>
        <p><b>4.4</b> We shall not release any information to any individual or entity that is acting beyond its legal
          mandate.</p>
        <p><br><b>4.5 Direct Marketing</b></p>
        <p><b><br>4.6.1 </b>You may be required to opt in or give any other form of explicit consent before receiving
          marketing messages from us.</p>
        <p><br><b>4.6.2</b> You can ask us to stop sending you marketing messages at any time by writing to us or logging
          into our website,<b> https://choice-bank.com</b> and checking or unchecking relevant boxes to adjust your
          marketing preferences or by following<br>the optout links on any marketing message sent to you or by attending
          to us or contacting us at any time through the provided contacts.</p>
        <p><br><b>4.6.3</b> Where you opt out of receiving these marketing messages, this will not apply to personal data
          provided to us as a result of a product, service already taken up, warranty registration, product or service
          experience or other transactions].</p>
        <p><br><b>5.0 The Use of Cookies</b></p>
        <p><b><br></b><b>5.1</b> We may store some information (using &#8220;cookies&#8221;) on your computer when you
          visit our websites. This enables us to recognize you during subsequent visits. The type of information gathered
          is non-personal (such as: the Internet Protocol (IP) address of<br>your computer, the date and time of your
          visit, which pages you browsed and whether the pages have been delivered successfully.</p>
        <p><br><b>5.2</b> We may also use this data in aggregate form to develop customized services &#8211; tailored to
          your individual interests and needs. Should you choose to do so, it is possible (depending on the browser you
          are using), to be prompted before accepting<br>any cookies, or to prevent your browser from accepting any
          cookies at all. This will however cause certain features of the web site not to be accessible or not to work as
          expected.</p>
        <p><br><b>6.0 The Use of Hyperlinks</b></p>
        <p><b><br>6.1</b> Our websites may provide hyperlinks to other locations or websites on the Internet. These
          hyperlinks lead to websites published or operated by third parties who are not affiliated with or in any way
          related to us and have been included in our website to enhance your user experience and are presented for
          information purposes only.</p>
        <p><br><b>6.2</b> We do not endorse, recommend, approve or guarantee any third- party products and services by
          providing hyperlinks to an external website or webpage and do not have any co-operation with such third parties
          unless otherwise disclosed. We are not in any way responsible for the content of any externally linked website
          or webpage.</p>
        <p><br><b>6.3</b> By clicking on a hyperlink, you will leave the Choice Bank webpage and accordingly you shall be
          subject to the terms of use, privacy and cookie policies of the other website that you choose to visit.</p>
        <p><br><b>7.0 Access to and Updating your Information</b><br>To update your information, please approach any of
          the Banks Branches with your request, or send an email request. You can change how we get in touch with you and
          your account details whenever you like.</p>
        <p><br><b>8.0 Safeguarding and Protection of Information</b><br>Choice Bank has put in place technical and
          operational measures to ensure integrity and confidentiality of your data via controls around: information
          classification, access control, cryptography, physical and environmental security and monitoring and compliance.
        </p>
        <p><br><b>9.0 International Data Transfers</b><br>From time to time we may need to transfer your personal
          information outside the Republic of Kenya to provide a particular product or service especially in regards to
          international funds remittance. Where we send your information outside Kenya, we will make sure that your
          information is properly protected in accordance with the applicable Data Protection Laws.</p>
        <p><br><b>10.0 Your Rights</b><br>Subject to legal and contractual exceptions, you have rights under data
          protection laws in relation to your personal data. These are listed below: &#8211;<br></p>
        <ul>
          <li>Right to be informed that we are collecting personal data about you;</li>
          <li>Right to access personal data that we hold about you and request for information about how we process it;
          </li>
          <li>Right to request that we correct your personal data where it is inaccurate or incomplete;</li>
          <li>Right to request that we erase your personal data noting that we may continue to retain your information if
            obligated by the law or entitled to do so;</li>
          <li>Right to object and withdraw your consent to processing of your personal data. We may continue to process if
            we have a legitimate or legal reason to do so;</li>
          <li>Right to request restricted processing of your personal data noting that we may be entitled or legally
            obligated to continue processing your data and refuse your request;</li>
          <li>Right to request transfer of your personal data in an electronic format.</li>
        </ul>
        <p><br>If you wish to exercise any of the rights set out above, please contact us on <b>risk@choice-bank.com</b>
          We may need to request specific information from you to help us confirm your identity and ensure your right to
          access your personal data (or to exercise any of your other rights). This is a security measure to ensure that
          personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you
          for further information in relation to your request to speed up our response. We try to respond to all
          legitimate requests within reasonable time. Occasionally it could take us longer if your request is particularly
          complex or you have made a number of requests. In this case, we will notify you and keep you updated.</p>
        <p><br><b>11.0 How to Contact Us</b><br>If you would like to contact us on any topics in this privacy policy, you
          can email us on risk@choicebank.com or submit a request via our website.</p>
        <p><br>As a Data Controller and Processor, below are the contact details of our Data Protection Officer:<br>Data
          Protection Officer Choice Microfinance Bank.</p>
        <p><br><b>Riverside Square, Riverside drive<br>P.O Box 29796 &#8211; 00100<br>Nairobi<br>Tel: +254 729 114 444<br>Mobile:
            +254731225879<br>https://choice-bank.com</b></p>
        <p><b><br></b><b>12.0 Right to Lodge Complaint</b><br>You have the right to lodge a complaint with the relevant
          supervisory authority that is tasked with personal data protection within the Republic of Kenya</p>
        <p><br><b>13.0 Non-Compliance with this Statement</b><br>Choice Bank shall have the right to terminate any
          agreement with you for failure to comply with the provisions of this statement and reject any application for
          information contrary to this statement.<br><br><b>14.0 Amendments to this Statement</b><br>Choice Bank reserves
          the right to amend or modify this statement at any time. If Choice Bank amends this statement, You can access
          the most current version of the privacy statement by clicking this link Choice Bank Privacy Statement so that
          you will always know how your personal information is being used or shared. Any amendment or modification to
          this statement will take effect from the date of notification on the Choice Bank website.</p>
        <p><br>Statement Effective Date<br><b>1st Jan 2022</b></p>

      </div>
    </div>

    <footer>
      <!-- <div class="fl" @click="GoTop">&copy;2021 Choice</div> -->
      <div class="fr" @click="GoTop">
        To the top
        <span class="arrow">↑</span>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    Go(route) {
      this.$router.push("/" + route);
    },
    GoTop() {
      let anchorElement = document.getElementById("top_bar");
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    },
  },
};
</script>
<style>
html,
body {
  padding: 0;
  margin: 0;
  background: #ffffff;
  width: 100%;
  height: 100%;
  font-size: 0;
}

div {
  margin: 0;
  padding: 0;
}

img {
  display: inline-block;
  margin: 0;
  padding: 0;
  border: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

div {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.header {
  max-width: 1200px;
  width: 100%;
  height: 90px;
  padding: 28px 0;
  overflow: hidden;
  margin: 0 auto;
}

@media screen and (min-width: 1200px) {
  .logo {
    width: 90px;
    height: 90px;
    cursor: pointer;
    float: left;
  }

  .nav_box {
    float: right;
    height: 90px;
    line-height: 90px;
  }

  .nav_list {
    height: 90px;
    line-height: 90px;
    display: inline-block;
    margin-left: 25px;
    cursor: pointer;
    color: #cd2653;
    font-size: 18px;
  }

  .h_title {
    font-size: 84px;
    height: 95px;
    text-align: center;
    width: 100%;
    font-weight: 700;
    padding: 80px 0;
  }
}

@media screen and (max-width: 800px) {
  .header {
    width: 100%;
    height: 40px;
    padding: 10px 0;
    overflow: hidden;
    margin: 0 auto;
  }

  .logo {
    width: 40px;
    height: 40px;
    cursor: pointer;
    float: left;
    margin-left: 2%;
  }

  .nav_box {
    float: right;
    height: 40px;
    line-height: 40px;
    width: 70%;
  }

  .nav_list {
    height: 40px;
    line-height: 40px;
    display: inline-block;
    cursor: pointer;
    color: #cd2653;
    font-size: 16px;
    margin-right: 2%;
  }

  .h_title {
    font-size: 36px;
    text-align: center;
    width: 100%;
    font-weight: 700;
    padding: 20px 0;
  }
}

.post_inner {
  padding: 80px 0;
  width: 100%;
  background-color: rgb(245, 239, 224);
}

.content {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  font-size: 21px;
  color: #000000;
  font-family: NonBreakingSpaceOverride, "Hoefler Text", Garamond,
    "Times New Roman", serif;
  line-height: 1.5;
  padding: 0 2%;
  box-sizing: border-box;
}

.content a {
  color: #cd2653;
}

footer {
  max-width: 1232px;
  width: 90%;
  margin: 0 auto;
  padding: 43px 0;
  overflow: hidden;
  height: 30px;
  font-size: 18px;
  box-sizing: border-box;
}

.fl {
  float: left;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  font-weight: 700;
}

.fr {
  float: right;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  color: #6d6d6d;
}

.content-area:not(.home) {
  max-width: 1232px;
  width: 90%;
  margin: 20px auto;
}

.entry-content p {
  font-size: 15px;
  color: #5e656f;
}

.entry-content h3 {
  font-size: 16px;
  font-weight: bold;
}

.entry-content ul {
  margin-left: 12px;
  padding: 0;
}

.entry-content ul li {
  display: list-item;
  margin: 12px 0;
  margin-top: 12px;
  margin-right: 0px;
  margin-bottom: 12px;
  margin-left: 0px;
  font-size: 15px;
  color: #5e656f;
}

.elementor-widget-text-editor.elementor-drop-cap-view-stacked .elementor-drop-cap {
  background-color: #69727d;
  color: #fff
}

.elementor-widget-text-editor.elementor-drop-cap-view-framed .elementor-drop-cap {
  color: #69727d;
  border: 3px solid;
  background-color: transparent
}

.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap {
  margin-top: 8px
}

.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap-letter {
  width: 1em;
  height: 1em
}

.elementor-widget-text-editor .elementor-drop-cap {
  float: left;
  text-align: center;
  line-height: 1;
  font-size: 50px
}

.elementor-widget-text-editor .elementor-drop-cap-letter {
  display: inline-block
}</style>
